import customConsortium from "images/brand-logos/Custom_Consortium_Logo.png";
import generalAssembly from "images/brand-logos/general-assembly-logo.svg";
import hearst from "images/brand-logos/hearst-logo.svg";
import food52 from "images/brand-logos/logo-food-52.svg";

/**
 * @typedef {Object} Testimonial
 * @property {string} quote - customer quote
 * @property {string} author - person's name
 * @property {string} role - job title / role at the company
 * @property {string} company - company name
 * @property {string} logo - imported brand logo URL
 */

/** @type {Testimonial[]} */
export const testimonials = [
  {
    quote:
      "DojoMojo is one of the easiest, most convenient tools I use in my day-to-day. I connect with new brands, easily organize upcoming opportunities, and stay up to date with current campaigns in real-time. I don't know how we would run our partnerships program without it. I'm bummed when a sweepstakes is not hosted on DojoMojo!",
    author: "Nicole Ribaudo",
    role: "Associate Manager, Email & Partnerships",
    company: "Hearst",
    logo: hearst,
  },
  {
    quote:
      "DojoMojo is an effective tool that has brought transparency to our sweepstakes acquisition campaigns, helping us scale this channel tremendously and hit our quarterly targets. We couldn't imagine our acquisition efforts without it.",
    author: "Lindsay Fitzgerald",
    role: "Marketing Partnerships Account Manager",
    company: "General Assembly",
    logo: generalAssembly,
  },
  {
    quote:
      "DojoMojo makes it easy for us to host sweepstakes on our own site! It's been a key component in helping us reach our email acquisition goals and has given us the additional benefit of boosting on-site traffic. We've also gotten greater insight into entrants which will continue to help inform our future sweepstakes strategies.",
    author: "Sophie Corwin",
    role: "Growth Marketing Coordinator",
    company: "Food52",
    logo: food52,
  },
  {
    quote:
      "DojoMojo is the rare service that delivers exactly what they promise...and then goes well beyond it. We're simply astonished by the effectiveness and simplicity of the platform to create sweepstakes and generate email leads. And if that's not enough, their support is absolutely top notch.",
    author: "Sam Payrovi",
    role: "CEO & Founder",
    company: "Custom Consortium",
    logo: customConsortium,
  },
];
